import { Outlet } from "react-router-dom";

import Sidebar from "components/Sidebar";
import { useDarkModeForNewDesign } from "hooks/useDarkModeForNewDesign";
import { cx } from "utils";


export default function SidebarLayout() {
  // the main section should only use the new design if we're on those pages (or on their subpages)
  const useDarkMode = useDarkModeForNewDesign();

  return (
    <div className="size-full flex flex-col md:flex-row">
      <div className="shrink-0 dark">
        <Sidebar />
      </div>
      {/* need to override the default minimum width, otherwise some features like text truncation won't work */}
      <div className="flex flex-col size-full min-w-0">
        <div className={ cx("flex-1 basis-0 overflow-y-auto", useDarkMode && "dark") }>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
